import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type RevenueModel = "PLATFORM_SUBSCRIPTION" | "TENANT_FEE_BASED" | "HYBRID";
export type AccountStatus = "ACTIVE" | "SUSPENDED" | "CLOSED" | "PENDING";

export interface TenantBillingAccount {
  id          : string;
  tenantId    : string;
  revenueModel: RevenueModel;
  status      : AccountStatus;
  currency    : string;
  accountNumber?: string | null;
  billingEmail?: string | null;
  // The tenant's operating businessId — passed to de-payment's bank verification as
  // myBusinessId (a tenant admin has no business on their JWT). Resolved server-side
  // in de-billing's /bil/my/billing-account; absent until that tenant is configured.
  operatingBusinessId?: string | null;
  createdAt?  : string;
}

export const getMy = () => httpRequest.get("/bil/my/billing-account") as Promise<TenantBillingAccount>;

// A business the tenant may pick as its fee-collection operating business. Deduped
// by regNumber server-side (BUYER/SUPPLIER rows share one regNumber).
export interface OperatingBusinessCandidate {
  businessId: string;
  profileName: string | null;
  regNumber: string;
}

export const listOperatingBusinessCandidates = () =>
  httpRequest.get("/bil/my/operating-business/candidates") as Promise<OperatingBusinessCandidate[]>;

export const setOperatingBusiness = (operatingBusinessId: string) =>
  httpRequest.put("/bil/my/billing-account/operating-business", { operatingBusinessId }) as Promise<TenantBillingAccount>;
